module.exports = __webpack_public_path__ + "static/img/MRI_2.08ae2039.jpg";